function convertYardsToFeet(num) {
  let eq =
    "Converting " + num + " yards to feet: \n" + num + " * 3 = ";
  let rep = num * 3;
  return eq + rep.toFixed(2);
}

function convertYardsToInches(num) {
  let eq =
    "Converting " +
    num +
    " yards to inches: \n" +
    num +
    " * 36 = ";
  let rep = num * 36;
  return eq + rep.toFixed(2);
}

function convertYardsToMiles(num) {
  let eq =
    "Converting " +
    num +
    " yards to miles: \n" +
    num +
    " * 0.00056818 = ";
  let rep = num * 0.00056818;
  return eq + rep.toFixed(5);
}

function convertYardsToMeters(num) {
  let eq =
    "Converting " +
    num +
    " yards to meters: \n" +
    num +
    " / 1.0936 = ";
  let rep = num / 1.0936;
  return eq + rep.toFixed(3);
}

function convertYardsToCM(num) {
  let eq =
    "Converting " +
    num +
    " yards to centimeters: \n" +
    num +
    " / 0.010936 = ";
  let rep = num / 0.010936;
  return eq + rep.toFixed(3);
}

function convertYardsToKilometers(num) {
  let eq =
    "Converting " +
    num +
    " yards to kilometers: \n" +
    num +
    " / 1093.6 = ";
  let rep = num / 1093.6;
  return eq + rep.toFixed(5);
}

export {
  convertYardsToFeet,
  convertYardsToInches,
  convertYardsToMiles,
  convertYardsToMeters,
  convertYardsToCM,
  convertYardsToKilometers
};
